import React from 'react';
import ReactDOM from "react-dom";
import 'font-awesome/css/font-awesome.min.css';

import App from './app';

import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);